import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "f030d66d-a657-4dcd-949b-6a910aefcc08"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooterF030d66dA6574dcd949b6a910aefcc08(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultFooterF030d66dA6574dcd949b6a910aefcc08 footer`}>
      {props["links"] || <Navigation className="LinksB30cd911F62843c7Bd8cA694a2660fa7" parentTag={buildClassName("LinksB30cd911F62843c7Bd8cA694a2660fa7", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="LogoA62097374c524de4A4e28a256cafb4f9" parentTag={buildClassName("LogoA62097374c524de4A4e28a256cafb4f9", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright891be754F58345b6898eE1dfa77fb4b7" parentTag={buildClassName("Copyright891be754F58345b6898eE1dfa77fb4b7", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="GroupflowD357927055f440448719C06c0cea81ae" parentTag={buildClassName("GroupflowD357927055f440448719C06c0cea81ae", parentTag)} {...props} />}
    </div>
  );
}

// id: "fc950811-542d-439d-a605-7555313dc07c"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTopFc950811542d439dA6057555313dc07c(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTopFc950811542d439dA6057555313dc07c header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogo7d02fdaa7b084c768100E1f09f905993" parentTag={buildClassName("LinkedLogo7d02fdaa7b084c768100E1f09f905993", parentTag)} label={<Logo className="LabelE9f8dd1bC89640e79427D5f11c8c869a" parentTag={buildClassName("LabelE9f8dd1bC89640e79427D5f11c8c869a", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} className="linked-logo" url="/" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="Navigation0fe3a599C31d431bAca1D2547276ca2d" parentTag={buildClassName("Navigation0fe3a599C31d431bAca1D2547276ca2d", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />}
    </div>
  );
}

// id: "17fd4270-4478-476c-a37e-f32e3244bbc5"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeader17fd42704478476cA37eF32e3244bbc5(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeader17fd42704478476cA37eF32e3244bbc5 site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopFc950811542d439dA6057555313dc07c parentTag="HeaderTop864aa7e531034dc2B36e93f8f6a5a81e" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHeroFef7372d9a2647378f02F0df1771f051 parentTag="Hero54521470A7524496B61eB863c5b157e2" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "facfd5a5-3bb4-4003-8eb3-6f148f93a763"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPageFacfd5a53bb440038eb36f148f93a763(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPageFacfd5a53bb440038eb36f148f93a763 gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader17fd42704478476cA37eF32e3244bbc5 parentTag="HeaderCb5b8b3290da487e8d37Cc34b81daf09" title="About Us" {...props} />}
      {props["main"] || <MainAbfa060b6cfa47c689b32c57fc9a03c6 />}
      {props["footer"] || <DefaultFooterF030d66dA6574dcd949b6a910aefcc08 parentTag="FooterBb609f50Ae964d45A1dfD111c19fd064" {...props} />}
    </div>
  );
}

// id: "2396dace-29b7-4e96-b625-a2e6ee4a585d"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPage2396dace29b74e96B625A2e6ee4a585d(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPage2396dace29b74e96B625A2e6ee4a585d`}>
      {props["header"] || <SecondaryMarketingHeader17fd42704478476cA37eF32e3244bbc5 parentTag="Header74c48191747a496d856b32e87782a2d6" title="Public Events" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterF030d66dA6574dcd949b6a910aefcc08 parentTag="Footer4f59af60453246609aceD5432dc71434" {...props} />}
    </div>
  );
}

// id: "fd465132-7202-4ea7-b2bc-a80ece8c4a7a"
// title: "Join Us Page"
// type: :reference
// key: "join-us-page"
// parent_id: nil
export function JoinUsPageFd46513272024ea7B2bcA80ece8c4a7a(props: any) {
  return (
    <SecondaryPageCd35312a9afc4977982059b7fff8dd08 parentTag="JoinUsPageFd46513272024ea7B2bcA80ece8c4a7a" header={<SecondaryMarketingHeader17fd42704478476cA37eF32e3244bbc5 parentTag="HeaderD89e285c5b50483b967b9cc1ad9f2aec" title="Join Us" />} {...props} />
  );
}

// id: "623e4ce8-fdf9-4b87-9902-875d2e78fd8b"
// title: "Member Application Pages"
// type: :reference
// key: "application-pages"
// parent_id: nil
export function ApplicationPages623e4ce8Fdf94b879902875d2e78fd8b(props: any) {
  return (
    <SecondaryPageCd35312a9afc4977982059b7fff8dd08 parentTag="ApplicationPages623e4ce8Fdf94b879902875d2e78fd8b" header={<SecondaryMarketingHeader17fd42704478476cA37eF32e3244bbc5 parentTag="Header106c273c962b498dA70071b6abb82c3e" title="Join Us" />} {...props} />
  );
}

// id: "cd35312a-9afc-4977-9820-59b7fff8dd08"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPageCd35312a9afc4977982059b7fff8dd08(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPageCd35312a9afc4977982059b7fff8dd08`}>
      {props["header"] || <SecondaryMarketingHeader17fd42704478476cA37eF32e3244bbc5 parentTag="HeaderEf57f534A0b54b4dB271859fc1c22af4" title="Secondary Page" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterF030d66dA6574dcd949b6a910aefcc08 parentTag="Footer7dc36291E78547a781423724905aac93" {...props} />}
    </div>
  );
}

// id: "fef7372d-9a26-4737-8f02-f0df1771f051"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHeroFef7372d9a2647378f02F0df1771f051(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeroFef7372d9a2647378f02F0df1771f051 hero`}>
      <h1 className="title">
        {props["title"] || Title69fb0e1d1f494187A1bc848198baad8c}
      </h1>
    </div>
  );
}

// id: "a6ff1abf-dfde-426b-bce8-43cddcf626d1"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePageA6ff1abfDfde426bBce843cddcf626d1(props: any) {
  const Header = AppStore.presets["Header"];
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePageA6ff1abfDfde426bBce843cddcf626d1 gf-page-layout`}>
      {props["header-wrapper"] || <HeaderWrapper99d480c7Fb484ca79a252b30f0a86bae />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack7f5b155052d74789Af341d29f6cba52c" parentTag={buildClassName("WelcomeBack7f5b155052d74789Af341d29f6cba52c", parentTag)} {...props} />}
      {props["main"] || <Main425852987fa744b3Bf184eed0abf0f07 />}
      {props["quote"] || <PageQuote className="QuoteAddefd02Ef2f4924B6d5096dcf883856" parentTag={buildClassName("QuoteAddefd02Ef2f4924B6d5096dcf883856", parentTag)} contentSlug="home-page-quote" {...props} />}
      {props["footer"] || <DefaultFooterF030d66dA6574dcd949b6a910aefcc08 parentTag="Footer56fb72c7B07b4504B520A44be78dff3b" {...props} />}
    </div>
  );
}

// id: "d3579270-55f4-4044-8719-c06c0cea81ae"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "f030d66d-a657-4dcd-949b-6a910aefcc08"
export function GroupflowD357927055f440448719C06c0cea81ae(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="GroupflowD357927055f440448719C06c0cea81ae" parentTag={buildClassName("GroupflowD357927055f440448719C06c0cea81ae", parentTag)} {...props} />
  );
}

// id: "8eabf6f5-371f-4a12-b185-03efbc642b14"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "fc950811-542d-439d-a605-7555313dc07c"
export function Logo8eabf6f5371f4a12B18503efbc642b14(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo8eabf6f5371f4a12B18503efbc642b14" parentTag={buildClassName("Logo8eabf6f5371f4a12B18503efbc642b14", parentTag)} logoType="DEFAULT" {...props} />
  );
}

// id: "864aa7e5-3103-4dc2-b36e-93f8f6a5a81e"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "17fd4270-4478-476c-a37e-f32e3244bbc5"
export function HeaderTop864aa7e531034dc2B36e93f8f6a5a81e(props: any) {
  return (
    <DefaultHeaderTopFc950811542d439dA6057555313dc07c parentTag="HeaderTop864aa7e531034dc2B36e93f8f6a5a81e" {...props} />
  );
}

// id: "a6209737-4c52-4de4-a4e2-8a256cafb4f9"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "f030d66d-a657-4dcd-949b-6a910aefcc08"
export function LogoA62097374c524de4A4e28a256cafb4f9(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LogoA62097374c524de4A4e28a256cafb4f9" parentTag={buildClassName("LogoA62097374c524de4A4e28a256cafb4f9", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "99d480c7-fb48-4ca7-9a25-2b30f0a86bae"
// title: "Home Header Wrapper"
// type: :html
// key: "header-wrapper"
// parent_id: "a6ff1abf-dfde-426b-bce8-43cddcf626d1"
export function HeaderWrapper99d480c7Fb484ca79a252b30f0a86bae(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeaderWrapper99d480c7Fb484ca79a252b30f0a86bae`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopFc950811542d439dA6057555313dc07c parentTag="HeaderTop1456fca590234db38b9bE6d0d8f32c04" {...props} />}
      </div>
      {props["hero-wrapper"] || <HeroWrapper01d7dca19c6040c5B56cA0675c4c55d3 />}
    </div>
  );
}

// id: "4f59af60-4532-4660-9ace-d5432dc71434"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "2396dace-29b7-4e96-b625-a2e6ee4a585d"
export function Footer4f59af60453246609aceD5432dc71434(props: any) {
  return (
    <DefaultFooterF030d66dA6574dcd949b6a910aefcc08 parentTag="Footer4f59af60453246609aceD5432dc71434" {...props} />
  );
}

// id: "7d02fdaa-7b08-4c76-8100-e1f09f905993"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "fc950811-542d-439d-a605-7555313dc07c"
export function LinkedLogo7d02fdaa7b084c768100E1f09f905993(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo7d02fdaa7b084c768100E1f09f905993" parentTag={buildClassName("LinkedLogo7d02fdaa7b084c768100E1f09f905993", parentTag)} label={<Logo className="LabelE9f8dd1bC89640e79427D5f11c8c869a" parentTag={buildClassName("LabelE9f8dd1bC89640e79427D5f11c8c869a", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} className="linked-logo" url="/" {...props} />
  );
}

// id: "69fb0e1d-1f49-4187-a1bc-848198baad8c"
// title: ""
// type: :text
// key: "title"
// parent_id: "fef7372d-9a26-4737-8f02-f0df1771f051"
export const Title69fb0e1d1f494187A1bc848198baad8c = "Default Title";

// id: "42585298-7fa7-44b3-bf18-4eed0abf0f07"
// title: "Home Main"
// type: :html
// key: "main"
// parent_id: "a6ff1abf-dfde-426b-bce8-43cddcf626d1"
export function Main425852987fa744b3Bf184eed0abf0f07(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} Main425852987fa744b3Bf184eed0abf0f07`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="CardsC7232df38ba849149d64Be6b556275a9" parentTag={buildClassName("CardsC7232df38ba849149d64Be6b556275a9", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "7f5b1550-52d7-4789-af34-1d29f6cba52c"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "a6ff1abf-dfde-426b-bce8-43cddcf626d1"
export function WelcomeBack7f5b155052d74789Af341d29f6cba52c(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack7f5b155052d74789Af341d29f6cba52c" parentTag={buildClassName("WelcomeBack7f5b155052d74789Af341d29f6cba52c", parentTag)} {...props} />
  );
}

// id: "abfa060b-6cfa-47c6-89b3-2c57fc9a03c6"
// title: ""
// type: :html
// key: "main"
// parent_id: "facfd5a5-3bb4-4003-8eb3-6f148f93a763"
export function MainAbfa060b6cfa47c689b32c57fc9a03c6(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} MainAbfa060b6cfa47c689b32c57fc9a03c6`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards0a214295E74d47d2B8cf08ec2dc0cb4b" parentTag={buildClassName("Cards0a214295E74d47d2B8cf08ec2dc0cb4b", parentTag)} postSlug="about-us-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "106c273c-962b-498d-a700-71b6abb82c3e"
// title: ""
// type: :reference
// key: "header"
// parent_id: "623e4ce8-fdf9-4b87-9902-875d2e78fd8b"
export function Header106c273c962b498dA70071b6abb82c3e(props: any) {
  return (
    <SecondaryMarketingHeader17fd42704478476cA37eF32e3244bbc5 parentTag="Header106c273c962b498dA70071b6abb82c3e" title="Join Us" {...props} />
  );
}

// id: "0fe3a599-c31d-431b-aca1-d2547276ca2d"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "fc950811-542d-439d-a605-7555313dc07c"
export function Navigation0fe3a599C31d431bAca1D2547276ca2d(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation0fe3a599C31d431bAca1D2547276ca2d" parentTag={buildClassName("Navigation0fe3a599C31d431bAca1D2547276ca2d", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "d89e285c-5b50-483b-967b-9cc1ad9f2aec"
// title: ""
// type: :reference
// key: "header"
// parent_id: "fd465132-7202-4ea7-b2bc-a80ece8c4a7a"
export function HeaderD89e285c5b50483b967b9cc1ad9f2aec(props: any) {
  return (
    <SecondaryMarketingHeader17fd42704478476cA37eF32e3244bbc5 parentTag="HeaderD89e285c5b50483b967b9cc1ad9f2aec" title="Join Us" {...props} />
  );
}

// id: "74c48191-747a-496d-856b-32e87782a2d6"
// title: ""
// type: :reference
// key: "header"
// parent_id: "2396dace-29b7-4e96-b625-a2e6ee4a585d"
export function Header74c48191747a496d856b32e87782a2d6(props: any) {
  return (
    <SecondaryMarketingHeader17fd42704478476cA37eF32e3244bbc5 parentTag="Header74c48191747a496d856b32e87782a2d6" title="Public Events" {...props} />
  );
}

// id: "1ac387d5-1d5f-43a2-929d-80504742bdf2"
// title: ""
// type: :text
// key: "title"
// parent_id: "17fd4270-4478-476c-a37e-f32e3244bbc5"
export const Title1ac387d51d5f43a2929d80504742bdf2 = "Secondary Marketing Title 1";

// id: "b30cd911-f628-43c7-bd8c-a694a2660fa7"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "f030d66d-a657-4dcd-949b-6a910aefcc08"
export function LinksB30cd911F62843c7Bd8cA694a2660fa7(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksB30cd911F62843c7Bd8cA694a2660fa7" parentTag={buildClassName("LinksB30cd911F62843c7Bd8cA694a2660fa7", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "ef57f534-a0b5-4b4d-b271-859fc1c22af4"
// title: ""
// type: :reference
// key: "header"
// parent_id: "cd35312a-9afc-4977-9820-59b7fff8dd08"
export function HeaderEf57f534A0b54b4dB271859fc1c22af4(props: any) {
  return (
    <SecondaryMarketingHeader17fd42704478476cA37eF32e3244bbc5 parentTag="HeaderEf57f534A0b54b4dB271859fc1c22af4" title="Secondary Page" {...props} />
  );
}

// id: "bb609f50-ae96-4d45-a1df-d111c19fd064"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "facfd5a5-3bb4-4003-8eb3-6f148f93a763"
export function FooterBb609f50Ae964d45A1dfD111c19fd064(props: any) {
  return (
    <DefaultFooterF030d66dA6574dcd949b6a910aefcc08 parentTag="FooterBb609f50Ae964d45A1dfD111c19fd064" {...props} />
  );
}

// id: "54521470-a752-4496-b61e-b863c5b157e2"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "17fd4270-4478-476c-a37e-f32e3244bbc5"
export function Hero54521470A7524496B61eB863c5b157e2(props: any) {
  return (
    <SecondaryMarketingHeroFef7372d9a2647378f02F0df1771f051 parentTag="Hero54521470A7524496B61eB863c5b157e2" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "cb5b8b32-90da-487e-8d37-cc34b81daf09"
// title: ""
// type: :reference
// key: "header"
// parent_id: "facfd5a5-3bb4-4003-8eb3-6f148f93a763"
export function HeaderCb5b8b3290da487e8d37Cc34b81daf09(props: any) {
  return (
    <SecondaryMarketingHeader17fd42704478476cA37eF32e3244bbc5 parentTag="HeaderCb5b8b3290da487e8d37Cc34b81daf09" title="About Us" {...props} />
  );
}

// id: "7dc36291-e785-47a7-8142-3724905aac93"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "cd35312a-9afc-4977-9820-59b7fff8dd08"
export function Footer7dc36291E78547a781423724905aac93(props: any) {
  return (
    <DefaultFooterF030d66dA6574dcd949b6a910aefcc08 parentTag="Footer7dc36291E78547a781423724905aac93" {...props} />
  );
}

// id: "891be754-f583-45b6-898e-e1dfa77fb4b7"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "f030d66d-a657-4dcd-949b-6a910aefcc08"
export function Copyright891be754F58345b6898eE1dfa77fb4b7(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright891be754F58345b6898eE1dfa77fb4b7" parentTag={buildClassName("Copyright891be754F58345b6898eE1dfa77fb4b7", parentTag)} {...props} />
  );
}

// id: "addefd02-ef2f-4924-b6d5-096dcf883856"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "a6ff1abf-dfde-426b-bce8-43cddcf626d1"
export function QuoteAddefd02Ef2f4924B6d5096dcf883856(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="QuoteAddefd02Ef2f4924B6d5096dcf883856" parentTag={buildClassName("QuoteAddefd02Ef2f4924B6d5096dcf883856", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "56fb72c7-b07b-4504-b520-a44be78dff3b"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "a6ff1abf-dfde-426b-bce8-43cddcf626d1"
export function Footer56fb72c7B07b4504B520A44be78dff3b(props: any) {
  return (
    <DefaultFooterF030d66dA6574dcd949b6a910aefcc08 parentTag="Footer56fb72c7B07b4504B520A44be78dff3b" {...props} />
  );
}

// id: "e9f8dd1b-c896-40e7-9427-d5f11c8c869a"
// title: "Home Page Logo"
// type: :gf_preset
// key: "label"
// parent_id: "7d02fdaa-7b08-4c76-8100-e1f09f905993"
export function LabelE9f8dd1bC89640e79427D5f11c8c869a(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LabelE9f8dd1bC89640e79427D5f11c8c869a" parentTag={buildClassName("LabelE9f8dd1bC89640e79427D5f11c8c869a", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />
  );
}

// id: "c7cb5536-e71a-4eda-8cdf-f66633943433"
// title: ""
// type: :text
// key: "class"
// parent_id: "0fe3a599-c31d-431b-aca1-d2547276ca2d"
export const ClassC7cb5536E71a4eda8cdfF66633943433 = "navigation";

// id: "fa280796-c698-4547-912e-5a73c40ae022"
// title: ""
// type: :text
// key: "class"
// parent_id: "7d02fdaa-7b08-4c76-8100-e1f09f905993"
export const ClassFa280796C6984547912e5a73c40ae022 = "linked-logo";

// id: "01d7dca1-9c60-40c5-b56c-a0675c4c55d3"
// title: ""
// type: :html
// key: "hero-wrapper"
// parent_id: "99d480c7-fb48-4ca7-9a25-2b30f0a86bae"
export function HeroWrapper01d7dca19c6040c5B56cA0675c4c55d3(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeroWrapper01d7dca19c6040c5B56cA0675c4c55d3`}>
      {props["hero"] || <Hero className="Hero681c7790Fb0148b18623B074e3c918da" parentTag={buildClassName("Hero681c7790Fb0148b18623B074e3c918da", parentTag)} postSlug="home-hero" {...props} />}
    </div>
  );
}

// id: "0a214295-e74d-47d2-b8cf-08ec2dc0cb4b"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "abfa060b-6cfa-47c6-89b3-2c57fc9a03c6"
export function Cards0a214295E74d47d2B8cf08ec2dc0cb4b(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards0a214295E74d47d2B8cf08ec2dc0cb4b" parentTag={buildClassName("Cards0a214295E74d47d2B8cf08ec2dc0cb4b", parentTag)} postSlug="about-us-cards" {...props} />
  );
}

// id: "f7961338-692d-4503-b8f8-4fd079e253ab"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "addefd02-ef2f-4924-b6d5-096dcf883856"
export const ContentSlugF7961338692d4503B8f84fd079e253ab = "home-page-quote";

// id: "1456fca5-9023-4db3-8b9b-e6d0d8f32c04"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "99d480c7-fb48-4ca7-9a25-2b30f0a86bae"
export function HeaderTop1456fca590234db38b9bE6d0d8f32c04(props: any) {
  return (
    <DefaultHeaderTopFc950811542d439dA6057555313dc07c parentTag="HeaderTop1456fca590234db38b9bE6d0d8f32c04" {...props} />
  );
}

// id: "8585285b-5a9c-41a7-b41d-411985723d69"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "8eabf6f5-371f-4a12-b185-03efbc642b14"
export const LogoType8585285b5a9c41a7B41d411985723d69 = "DEFAULT";

// id: "3577eec4-3d0f-4ecb-9d7b-d45b87193d08"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "0fe3a599-c31d-431b-aca1-d2547276ca2d"
export const NavMenuSlug3577eec43d0f4ecb9d7bD45b87193d08 = "marketing-primary-nav";

// id: "6d004a60-2b30-47b0-997b-b628a17eab8e"
// title: ""
// type: :text
// key: "title"
// parent_id: "ef57f534-a0b5-4b4d-b271-859fc1c22af4"
export const Title6d004a602b3047b0997bB628a17eab8e = "Secondary Page";

// id: "8b238f15-9d94-40f2-bf71-a9259d8e2194"
// title: ""
// type: :text
// key: "title"
// parent_id: "74c48191-747a-496d-856b-32e87782a2d6"
export const Title8b238f159d9440f2Bf71A9259d8e2194 = "Public Events";

// id: "20682a74-33cf-4baa-814e-cb44c0006f35"
// title: ""
// type: :text
// key: "url"
// parent_id: "7d02fdaa-7b08-4c76-8100-e1f09f905993"
export const Url20682a7433cf4baa814eCb44c0006f35 = "/";

// id: "c7232df3-8ba8-4914-9d64-be6b556275a9"
// title: "Home Cards"
// type: :gf_preset
// key: "cards"
// parent_id: "42585298-7fa7-44b3-bf18-4eed0abf0f07"
export function CardsC7232df38ba849149d64Be6b556275a9(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="CardsC7232df38ba849149d64Be6b556275a9" parentTag={buildClassName("CardsC7232df38ba849149d64Be6b556275a9", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-cards" {...props} />
  );
}

// id: "82db5993-b827-48b2-a6de-edcaf5bc1761"
// title: ""
// type: :text
// key: "title"
// parent_id: "d89e285c-5b50-483b-967b-9cc1ad9f2aec"
export const Title82db5993B82748b2A6deEdcaf5bc1761 = "Join Us";

// id: "58f1d57d-3b66-4f11-9ccf-1c1825d42059"
// title: ""
// type: :text
// key: "title"
// parent_id: "106c273c-962b-498d-a700-71b6abb82c3e"
export const Title58f1d57d3b664f119ccf1c1825d42059 = "Join Us";

// id: "cfb2c576-f878-449c-90f7-964ee557d3eb"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "b30cd911-f628-43c7-bd8c-a694a2660fa7"
export const NavMenuSlugCfb2c576F878449c90f7964ee557d3eb = "footer-nav";

// id: "3c7bd16a-8eed-47c2-90c6-c554cb46a1ff"
// title: ""
// type: :text
// key: "title"
// parent_id: "cb5b8b32-90da-487e-8d37-cc34b81daf09"
export const Title3c7bd16a8eed47c290c6C554cb46a1ff = "About Us";

// id: "037c2967-1ae5-4ff4-8bee-24b08fe06991"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "a6209737-4c52-4de4-a4e2-8a256cafb4f9"
export const LogoType037c29671ae54ff48bee24b08fe06991 = "FOOTER";

// id: "b3ba4ac1-af40-4069-a1f6-fc280425cc7c"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "a6209737-4c52-4de4-a4e2-8a256cafb4f9"
export const ContentSlugB3ba4ac1Af404069A1f6Fc280425cc7c = "footer-logo";

// id: "0fd1637f-81dd-4583-9ce9-5d4f6b76e13d"
// title: ""
// type: :text
// key: "title"
// parent_id: "54521470-a752-4496-b61e-b863c5b157e2"
export const Title0fd1637f81dd45839ce95d4f6b76e13d = "Secondary Marketing Title 2";

// id: "999d0f5d-f533-4522-bbdf-41e871984dde"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "c7232df3-8ba8-4914-9d64-be6b556275a9"
export const ButtonClass999d0f5dF5334522Bbdf41e871984dde = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "1ab9b270-1b6b-4743-a5e7-e8e0bd5acba9"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "c7232df3-8ba8-4914-9d64-be6b556275a9"
export const PostSlug1ab9b2701b6b4743A5e7E8e0bd5acba9 = "home-page-cards";

// id: "681c7790-fb01-48b1-8623-b074e3c918da"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "01d7dca1-9c60-40c5-b56c-a0675c4c55d3"
export function Hero681c7790Fb0148b18623B074e3c918da(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="Hero681c7790Fb0148b18623B074e3c918da" parentTag={buildClassName("Hero681c7790Fb0148b18623B074e3c918da", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "b3d850ad-e13f-4bc1-b69f-a26a1ff0ff21"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "e9f8dd1b-c896-40e7-9427-d5f11c8c869a"
export const LogoTypeB3d850adE13f4bc1B69fA26a1ff0ff21 = "DEFAULT";

// id: "febe5190-dfc3-4a43-8abd-bee3d7cbb5dc"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "0a214295-e74d-47d2-b8cf-08ec2dc0cb4b"
export const PostSlugFebe5190Dfc34a438abdBee3d7cbb5dc = "about-us-cards";

// id: "6e7f01e8-1eb6-4803-a7fb-8e29b22f1790"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "e9f8dd1b-c896-40e7-9427-d5f11c8c869a"
export const ContentSlug6e7f01e81eb64803A7fb8e29b22f1790 = "header-logo";

// id: "1a659108-718b-4479-a4d0-848d3d49ad86"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "681c7790-fb01-48b1-8623-b074e3c918da"
export const PostSlug1a659108718b4479A4d0848d3d49ad86 = "home-hero";

const Components = {
  DefaultFooterF030d66dA6574dcd949b6a910aefcc08,
  DefaultHeaderTopFc950811542d439dA6057555313dc07c,
  SecondaryMarketingHeader17fd42704478476cA37eF32e3244bbc5,
  AboutUsPageFacfd5a53bb440038eb36f148f93a763,
  PublicEventsPage2396dace29b74e96B625A2e6ee4a585d,
  JoinUsPageFd46513272024ea7B2bcA80ece8c4a7a,
  ApplicationPages623e4ce8Fdf94b879902875d2e78fd8b,
  SecondaryPageCd35312a9afc4977982059b7fff8dd08,
  SecondaryMarketingHeroFef7372d9a2647378f02F0df1771f051,
  HomePageA6ff1abfDfde426bBce843cddcf626d1,
  GroupflowD357927055f440448719C06c0cea81ae,
  Logo8eabf6f5371f4a12B18503efbc642b14,
  HeaderTop864aa7e531034dc2B36e93f8f6a5a81e,
  LogoA62097374c524de4A4e28a256cafb4f9,
  HeaderWrapper99d480c7Fb484ca79a252b30f0a86bae,
  Footer4f59af60453246609aceD5432dc71434,
  LinkedLogo7d02fdaa7b084c768100E1f09f905993,
  Title69fb0e1d1f494187A1bc848198baad8c,
  Main425852987fa744b3Bf184eed0abf0f07,
  WelcomeBack7f5b155052d74789Af341d29f6cba52c,
  MainAbfa060b6cfa47c689b32c57fc9a03c6,
  Header106c273c962b498dA70071b6abb82c3e,
  Navigation0fe3a599C31d431bAca1D2547276ca2d,
  HeaderD89e285c5b50483b967b9cc1ad9f2aec,
  Header74c48191747a496d856b32e87782a2d6,
  Title1ac387d51d5f43a2929d80504742bdf2,
  LinksB30cd911F62843c7Bd8cA694a2660fa7,
  HeaderEf57f534A0b54b4dB271859fc1c22af4,
  FooterBb609f50Ae964d45A1dfD111c19fd064,
  Hero54521470A7524496B61eB863c5b157e2,
  HeaderCb5b8b3290da487e8d37Cc34b81daf09,
  Footer7dc36291E78547a781423724905aac93,
  Copyright891be754F58345b6898eE1dfa77fb4b7,
  QuoteAddefd02Ef2f4924B6d5096dcf883856,
  Footer56fb72c7B07b4504B520A44be78dff3b,
  LabelE9f8dd1bC89640e79427D5f11c8c869a,
  ClassC7cb5536E71a4eda8cdfF66633943433,
  ClassFa280796C6984547912e5a73c40ae022,
  HeroWrapper01d7dca19c6040c5B56cA0675c4c55d3,
  Cards0a214295E74d47d2B8cf08ec2dc0cb4b,
  ContentSlugF7961338692d4503B8f84fd079e253ab,
  HeaderTop1456fca590234db38b9bE6d0d8f32c04,
  LogoType8585285b5a9c41a7B41d411985723d69,
  NavMenuSlug3577eec43d0f4ecb9d7bD45b87193d08,
  Title6d004a602b3047b0997bB628a17eab8e,
  Title8b238f159d9440f2Bf71A9259d8e2194,
  Url20682a7433cf4baa814eCb44c0006f35,
  CardsC7232df38ba849149d64Be6b556275a9,
  Title82db5993B82748b2A6deEdcaf5bc1761,
  Title58f1d57d3b664f119ccf1c1825d42059,
  NavMenuSlugCfb2c576F878449c90f7964ee557d3eb,
  Title3c7bd16a8eed47c290c6C554cb46a1ff,
  LogoType037c29671ae54ff48bee24b08fe06991,
  ContentSlugB3ba4ac1Af404069A1f6Fc280425cc7c,
  Title0fd1637f81dd45839ce95d4f6b76e13d,
  ButtonClass999d0f5dF5334522Bbdf41e871984dde,
  PostSlug1ab9b2701b6b4743A5e7E8e0bd5acba9,
  Hero681c7790Fb0148b18623B074e3c918da,
  LogoTypeB3d850adE13f4bc1B69fA26a1ff0ff21,
  PostSlugFebe5190Dfc34a438abdBee3d7cbb5dc,
  ContentSlug6e7f01e81eb64803A7fb8e29b22f1790,
  PostSlug1a659108718b4479A4d0848d3d49ad86
}

export default Components;